import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { catchError, retry } from "rxjs/operators";
import { environment } from "src/environments/environment";

/**
 * Versión de la aplicación para el panel de perfil.
 * - Front: `environment.version` (lo inyecta el pipeline DevOps al desplegar,
 *   sustituyendo el literal `VERSION_TAG`; en local muestra ese literal).
 * - Back: endpoint aditivo `GET {api.root}{endpoint.version.get}` → `{ version }`.
 *   Tolerante a fallos: si no responde, devuelve versión vacía.
 */
@Injectable({ providedIn: "root" })
export class VersionService {
	constructor(private readonly http: HttpClient) {}

	getFrontVersion(): string {
		return (environment as any).version || "";
	}

	getBackVersion(): Observable<{ version: string }> {
		const url = `${environment.api.root}${environment.endpoint.version.get}`;
		return this.http.get<{ version: string }>(url).pipe(
			retry(2),
			catchError(() => of({ version: "" })),
		);
	}
}
